// src/registered/site-admin/components/Workflow-esg/views/TemplateBuilderMainView.jsx
import React, { useState, useMemo } from "react";

export default function TemplateBuilderMainView(props) {
  const { 
    loading, 
    inventory, 
    selectedFile, 
    onSelect, 
    onBack, 
    onReturnToDashboard, 
    children 
  } = props;
  
  const [query, setQuery] = useState("");

  const filtered = useMemo(() => {
    const list = Array.isArray(inventory) ? inventory : [];
    return list.filter((f) => {
      const name = f?.filename || f?.fileName || f?.key || f?.name || "";
      return name.toLowerCase().includes(query.toLowerCase());
    });
  }, [inventory, query]);

  const selectedName = selectedFile?.filename || selectedFile?.fileName || selectedFile?.key || selectedFile?.name || "";

  return (
    <div className="page-main" data-scroll-container>
      <div className="page-main-inner">
        {/* 🎯 Updated spacing to match workflow section padding */}
        <main id="main" className="page-section px-4 mt-5 pt-5">
          <div className="container">
            <div className="card shadow-sm border-0 bg-white">
              {/* 🎯 FIXED: Header now matches the Workflow Roadmap style (White bg, Dark Text) */}
              <div className="card-header bg-white border-bottom p-4 d-flex justify-content-between align-items-center">
                <h5 className="mb-0 fw-bold text-dark">Template Builder Manager</h5>
                <button 
                  className="btn btn-sm btn-outline-secondary fw-bold text-uppercase" 
                  style={{ fontSize: '0.75rem', letterSpacing: '0.5px' }}
                  onClick={onBack}
                >
                  <i className="bi bi-arrow-left me-2"></i>
                  Return to Menu
                </button>
              </div>

              <div className="card-body p-4 bg-light bg-opacity-50">
                {/* SECTION 1: INVENTORY */}
                <div className="card shadow-sm border-0 mb-4">
                  <div className="card-body p-4">
                    <label className="small fw-bold text-muted mb-3 d-block text-uppercase">1. Search & Select Inventory Source</label>
                    <input
                      type="text"
                      className="form-control form-control-lg mb-3 shadow-none border-primary-subtle"
                      placeholder="Filter inventory files..."
                      value={query}
                      onChange={(e) => setQuery(e.target.value)}
                    />
                    {loading ? (
                      <div className="text-center py-5"><div className="spinner-border text-primary"></div></div>
                    ) : (
                      <div className="table-responsive border rounded bg-white" style={{ maxHeight: "300px", overflowY: "auto" }}>
                        <table className="table table-hover mb-0">
                          <thead className="table-light sticky-top small text-uppercase">
                            <tr><th style={{ width: "50px" }}>Status</th><th>Resource / Filename</th><th className="text-end px-4">Action</th></tr>
                          </thead>
                          <tbody>
                            {filtered.map((file, i) => {
                              const fName = file?.filename || file?.fileName || file?.key || file?.name || "Unnamed";
                              const isSelected = selectedName === fName;
                              return (
                                <tr key={i} className={isSelected ? "table-primary" : "cursor-pointer"} onClick={() => onSelect(file)}>
                                  <td className="text-center"><input type="checkbox" className="form-check-input" checked={isSelected} readOnly /></td>
                                  <td><span className={`fw-bold ${isSelected ? "text-primary" : "text-dark"}`}>{fName}</span></td>
                                  <td className="text-end px-4">
                                    <button className={`btn btn-sm ${isSelected ? "btn-primary" : "btn-outline-primary"} fw-bold`}>
                                      {isSelected ? "Selected" : "Select"}
                                    </button>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                </div>

                {/* SECTION 2: BUILDER ACTIONS */}
                <div className="card shadow-sm border-0 mb-4">
                  <div className="card-body p-4">
                    <label className="small fw-bold text-muted mb-3 d-block text-uppercase">2. Builder Actions</label>
                    <label className="small fw-bold text-muted d-block mb-1 text-uppercase">Active Selection</label>
                    <div className="p-3 border rounded bg-white fw-bold text-primary shadow-sm">
                      {selectedName || "No resource selected..."}
                    </div>
                  </div>
                </div>

                {/* 🎯 INJECTION POINT: Steps 3, 4, etc. */}
                {children}

                {/* 🎯 GLOBAL FOOTER */}
                <div className="mt-5 border-top pt-4 d-flex justify-content-between align-items-center">
                  <button className="btn btn-link text-decoration-none p-0 text-secondary small" onClick={onReturnToDashboard}>
                    <i className="bi bi-arrow-left me-2"></i>
                    Return to ESG Taxonomy Workflow
                  </button>
                  <span className="text-muted small italic">
                    ESG Template Management System v1.1
                  </span>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}